import { studioSectionOpen } from '@/viewmodel/features/dashboard/mappers/studioSections';
import type { PresentationSection } from '@/viewmodel/features/dashboard/types';
import { useIsStaffViewModel } from '@/viewmodel/features/user';

export function useStudioSectionOpen(section: PresentationSection): boolean {
  return studioSectionOpen(section, useIsStaffViewModel());
}
